import {Link} from 'gatsby'
import React from 'react'
import BlogPostPreview from './blog-post-preview'

import * as styles from './blog-post-preview-list.module.css'


function BlogPostPreviewGrid (props) {

  var nodes = (props || {}).nodes

  // fitler to page_type
  if (props.page_type_name){
    nodes = nodes.filter( node => node.page_type.name===props.page_type_name)
  }

  // filter to the site_section
  if (props.site_section_name){
    nodes = nodes.filter( node => node.site_section.name===props.site_section_name)
  }

  // sort by page value
  nodes.sort((a, b) => (a.page_value > b.page_value) ? -1 : 1)

  // filter to a max_n
  if (props.max_n){
    nodes = nodes
      .slice(0,props.max_n)
  }

  return (
    <div className={styles.root}>
      {props.title && <h2 className={styles.headline}>{props.title}</h2>}
      <ul className={styles.grid}>
        {nodes &&
          nodes.map(node => (
            <li key={`${node.id}_${node.slug}`}>
              <BlogPostPreview {...node} target_width={props.target_width} isInList />
            </li>
          ))}
      </ul>
      {props.browseMoreHref && (
        <div className={styles.browseMoreNav}>
          <Link to={props.browseMoreHref}>Browse more</Link>
        </div>
      )}
    </div>
  )
}

BlogPostPreviewGrid.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: ''
}

export default BlogPostPreviewGrid
